module.exports = __webpack_public_path__ + "static/media/OCFL_IMG-Mobile.1fb28ae2.png";